import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Youtube, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    company: [
      { name: 'About', href: '/about' },
      { name: 'Press', href: '/press' },
      { name: 'Contact Us', href: '/contact' },
    ],
    product: [
      { name: 'How It Works', href: '/how-it-works' },
      { name: 'Markets', href: '/markets' },
      { name: 'Leaderboard', href: '/leaderboard' },
      { name: "Today's Picks", href: '/picks' },
      { name: 'Learn', href: '/learn' },
    ],
    apps: [
      { name: 'Web App', href: '/' },
      { name: 'iOS App', href: '/ios' },
      { name: 'Android App', href: '/android' },
      { name: 'Download', href: '/app' },
    ],
    legal: [
      { name: 'Terms of Use (EULA)', href: '/eula' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Refund Policy', href: '/refund-policy' },
      { name: 'Billing', href: '/profile/billing' },
    ],
  };

  return (
    <footer className="bg-[#070a12] text-gray-400 border-t border-[#1e2a45]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2">
              <img
                src="/brand/amppredict-logo.png"
                alt="amppredict"
                className="h-10 w-auto"
                draggable={false}
              />
              <span className="text-xs font-medium text-[#F97316] bg-[#F97316]/10 px-2 py-0.5 rounded-full border border-[#F97316]/20">Mock Predictions</span>
            </Link>
            <p className="mt-4 text-sm text-gray-500 leading-relaxed">
              A mock prediction simulation for educational purposes to gauge the pulse of the company. No real money involved and it is user driven but moderated.
            </p>
            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-6">
              <a href="#" className="text-gray-500 hover:text-[#3B82F6] transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-[#3B82F6] transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-[#3B82F6] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-[#3B82F6] transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Product
            </h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Apps
            </h4>
            <ul className="space-y-3">
              {footerLinks.apps.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Legal &amp; Support
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-[#3B82F6] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1e2a45] mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} AMP (Mock Predictions). All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <span className="text-xs text-gray-600">
                Mock Trading Only
              </span>
              <span className="text-xs text-gray-600">
                No Real Money
              </span>
            </div>
          </div>
          <p className="mt-6 text-xs text-gray-700 leading-relaxed max-w-4xl">
            This is a simulation platform using mock tokens. No real money is involved.
            This platform is for educational and entertainment purposes only.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
